import {useEffect} from "react";
import {Navigate, Route, Routes} from "react-router";
import {useSelector} from "react-redux";
import {
    DispatchBoard,
    Employees,
    Facilities,
    Home,
    LoginPage,
    Patients,
    Payers, PendingTrips, Privacy,
    Users,
    Vehicles,
} from "pages";
import {Layout} from "fragments";
import {InactivityHandler, isAdmin, PermissionsList, RolePermission} from "../utils";

export const Routers = () => {
    const {accessToken} = useSelector((state) => ({
        accessToken: state.auth.accessToken,
    }));
    const token = accessToken
        ? accessToken
        : localStorage.getItem("access-token");
    const link = window.location.search;

    useEffect(() => {
        if (link.search("token=") !== -1 || link.search("resetToken=") !== -1) {
            localStorage.clear();
            sessionStorage.clear();
        }
    }, []);

    const showUnAuthorizedRoutes =  !token || !isAdmin || link.includes("resetToken=") || link.includes("token=");

    return (
        <>
            <Routes>
                {showUnAuthorizedRoutes ? (
                    <>
                        <Route path={"/"} element={<Home/>}/>
                        <Route path="/login" element={<LoginPage/>}/>
                        <Route path="/forgot" element={<LoginPage/>}/>
                        <Route path="/resetPassword/:resetToken?" element={<LoginPage/>}/>
                        <Route path="/register/:token?" element={<LoginPage/>}/>
                        <Route path="/privacy" element={<Privacy/>}/>
                        <Route path="*" element={<Navigate to="/"/>}/>
                    </>
                ) : (
                    <>
                        <Route path={"/"} element={<Layout/>}>
                            <Route index element={<Navigate to="/dispatch-board" />} />

                            {RolePermission([PermissionsList.ALL_ACCESS.code]) &&
                                <Route path={"/users"} element={<Users/>}/>
                            }
                            <Route path={"/employees"} element={<Employees/>}/>
                            <Route path={"/facilities"} element={<Facilities/>}/>
                            <Route path={"/payers"} element={<Payers/>}/>
                            <Route path={"/patients"} element={<Patients/>}/>
                            <Route path={"/dispatch-board"} element={<DispatchBoard/>}/>
                            <Route path={"/pending-trips"} element={<PendingTrips/>}/>
                            <Route path={"/vehicles"} element={<Vehicles/>}/>
                            <Route path="/privacy" element={<Privacy/>}/>

                            <Route path="*" index element={<Navigate to="/dispatch-board"/>}/>
                        </Route>
                    </>
                )}
            </Routes>
            {!showUnAuthorizedRoutes && <InactivityHandler />}
        </>
    );
};
